import type { JSONContent } from '@tiptap/core'
import type { Node as PMNode } from '@tiptap/pm/model'

/** Một dòng = một paragraph (khớp editor.getText({ blockSeparator: '\\n' })). */
export function plainTextToTiptapJSON(text: string): JSONContent {
  const lines = text.split('\n')
  return {
    type: 'doc',
    content: lines.map((line) => ({
      type: 'paragraph',
      content: line.length > 0 ? [{ type: 'text', text: line }] : [],
    })),
  }
}

/** Offset trong chuỗi textBetween(0, pos) ↔ vị trí PM (dùng cho decoration / xóa gợi ý). */
export function pmPositionToStringOffset(doc: PMNode, pos: number): number {
  const p = Math.max(0, Math.min(pos, doc.content.size))
  return doc.textBetween(0, p, '\n', '\n').length
}

export function stringOffsetToPmPosition(doc: PMNode, offset: number): number {
  const max = doc.content.size
  const fullLen = doc.textBetween(0, max, '\n', '\n').length
  if (offset <= 0) return 0
  if (offset >= fullLen) return max
  let low = 0
  let high = max
  while (low < high) {
    const mid = Math.floor((low + high + 1) / 2)
    const len = doc.textBetween(0, mid, '\n', '\n').length
    if (len < offset) low = mid
    else high = mid - 1
  }
  return low
}
